<div class="row">
    <div class="col-md-12">
        <div class="emptyDiv">
            <div class="emptyIcon">
                <img  src="/assets/images/empty.png">
            </div>
        </div>
    </div>
</div>